export default {
	API_URL: 'https://d3ripn363yee4i.cloudfront.net/NasUser/',
};